


































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_altinnTaxInvoicePreviews_altinnTaxInvoicePreviews } from '@/queries/__generated__/altinnTaxInvoicePreviews';

@Component
export default class AltinnTaxInvoicePreview extends Vue {
  @Prop({ type: Object, required: true }) private preview!: GQL_altinnTaxInvoicePreviews_altinnTaxInvoicePreviews;
}
